<template>
  <div class="countdown" :class="{ 'countdown--ar': lang === 'ar' }">
    <div class="countdown__container">
      <div class="countdown__text" v-view="viewHandlerText" ref="text">
        <h2>{{ getText("countdown_headline") }}</h2>
        <p v-html="getText('countdown_copy')"></p>
        <button @click="$store.commit('set_newsletter', true)">
          {{ getText("countdown_button") }}
        </button>
      </div>
      <div class="countdown__bubbles" v-view="viewHandlerBubbles" ref="bubbles">
        <div class="countdown__bubbles-wrapper">
          <!-- <div class="countdown__bubble countdown__bubble--months">
            <div class="countdown__bubble-text">
              <h2>{{ countdown.months }}</h2>
              <h3>{{ getText("countdown_label_months") }}</h3>
            </div>
          </div> -->
          <div class="countdown__bubble countdown__bubble--days">
            <div class="countdown__bubble-text">
              <h2>{{ countdown.days }}</h2>
              <h3>{{ getText("countdown_label_days") }}</h3>
            </div>
          </div>
          <div class="countdown__bubble countdown__bubble--hours">
            <div class="countdown__bubble-text">
              <h2>{{ countdown.hours }}</h2>
              <h3>{{ getText("countdown_label_hours") }}</h3>
            </div>
          </div>
          <div class="countdown__bubble countdown__bubble--minutes">
            <div class="countdown__bubble-text">
              <h2>{{ countdown.minutes }}</h2>
              <h3>{{ getText("countdown_label_minutes") }}</h3>
            </div>
          </div>
          <div class="countdown__bubble countdown__bubble--seconds">
            <div class="countdown__bubble-text">
              <h2>{{ countdown.seconds }}</h2>
              <h3>{{ getText("countdown_label_seconds") }}</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import gsap from "gsap";
import ContentMixin from "@/mixins/ContentMixin";
import moment from "moment";
require("moment-precise-range-plugin");
export default {
  name: "Countdown",
  mixins: [ContentMixin],
  props: {},
  data() {
    return {
      bubblesShown: undefined,
      textShown: undefined,
      countdown: {
        // months: 0,
        days: 0,
        seconds: 0,
        weeks: 0,
        minutes: 0,
        hours: 0,
      },
      targetDate: "2021-10-01T08:00:00+03:00",
    };
  },
  computed: {},
  watch: {},
  methods: {
    viewHandlerBubbles(e) {
      if (!this.textbooklet) return;
      if (this.bubblesShown) return;

      if (e.percentInView >= 0.6) {
        this.bubblesShown = true;

        const bubbles = this.$refs.bubbles.getElementsByClassName(
          "countdown__bubble"
        );
        gsap.from(bubbles, {
          duration: 1.5,
          scale: 0.8,
          ease: "back",
          stagger: 0.2,
        });

        gsap.to(bubbles, {
          duration: 0.25,
          autoAlpha: 1,
          stagger: 0.2,
        });
      }
    },
    viewHandlerText(e) {
      if (e.type === "enter") {
        gsap.to(this.$refs.text, { duration: 2, y: 0 });
        gsap.to(this.$refs.text, { autoAlpha: 1 });
      }
    },
    updateCountdown() {
      const m1 = moment(Date.now());
      const m2 = moment(this.targetDate);
      this.countdown = moment.preciseDiff(m1, m2, true);
      this.countdown.days += (30*this.countdown.months);
    },
  },

  mounted() {
    this.interval = setInterval(this.updateCountdown, 1000);
    //
    this.$nextTick(() => {
      this.updateCountdown();

      const bubbles = this.$refs.bubbles.getElementsByClassName(
        "countdown__bubble"
      );

      gsap.set(bubbles, {
        autoAlpha: 0,
      });

      gsap.set(this.$refs.text, { y: 100, autoAlpha: 0 });
    });
  },
  beforeDestroy() {
    clearInterval(this.interval);
    this.interval = undefined;
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
